import { RouteMetadata } from './types';

export const dashboardsMetadata: RouteMetadata[] = [
    {
        pattern: '/agents/:agentId/dashboards/:dashboardId',
        section: 'dashboards',
        view: 'details',
        descriptionTemplate: 'User is viewing dashboard {dashboardId}',
        capabilities: [
            'Add, edit, and remove dashboard panels',
            'Configure chart queries and visualization formats',
            'Adjust dashboard refresh and time range settings',
            'Analyze key metrics in a unified view',
        ],
        hints: [
            'Dashboards are composed of panels backed by metric queries',
            'Panel configuration controls chart type, fields, and formatting',
            'Layout order communicates priority from top-left to bottom-right',
        ],
    },
    {
        pattern: '/agents/:agentId/dashboards',
        section: 'dashboards',
        view: 'list',
        descriptionTemplate: 'User is viewing the dashboards list',
        capabilities: [
            'Browse existing dashboards',
            'Create a new dashboard',
            'Rename or delete dashboards',
            'Open a dashboard to edit panels',
        ],
        hints: [
            'Dashboards provide curated views of business and product health',
            'Start with KPI panels, then add trend and breakdown charts',
            'Open dashboard details to configure panel-level queries',
        ],
    },
];
